// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
  -moz-column-count: 2;
  -moz-column-gap: 20px;
  -webkit-column-count: 2;
  -webkit-column-gap: 20px;
  column-count: 2;
  column-gap: 20px;
}

tr.example-detail-row {
  height: 0;
}

tr.example-element-row:not(.example-expanded-row):active {
  background: #efefef;
}

.example-element-row td {
  border-bottom-width: 0;
}

.example-element-detail {
  overflow: hidden;
  display: flex;
}

.childTable {
  width: 100%;
}

td.mat-cell {
  width: auto;
  max-width: 10% !important;
}

mat-row {
  width: auto;
  max-width: 10% !important;
}

tr.mat-row {
  height: auto;
}

.mat-column-uredi {
  width: 5% !important;
}
.mat-column-dataCode {
  width: 20%;
}
.mat-column-dataValue {
  width: 80%;
}

.mat-header-cell {
  background-color: #f89624;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}

.parentTableCell {
  background-color:#ffe8bf !important;
}

.parentTableCell:nth-child(4n+1) {
  background-color:#FFF5E3 !important;
}

/*table coloring*/
.colorExpandedRow{
  background-color:#ffe8bf;
}

/*table coloring*/
.colorExpandedRow:nth-child(4n+2){
  background-color:#FFF5E3;
}

.tableGtSm {
  height:100%;
  width:100%;
}

.sidebarLtMd {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: #f1f1f1;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  animation: slide-in 0.5s forwards;
  -webkit-animation: slide-in 0.5s forwards;
}

.sidebar {
  margin: 0;
  padding: 0;
  width: 300px;
  display:flex !important;
  background-color: #f1f1f1;
  position: fixed;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
}
.contentLtMd {
  width: 100%;
  overflow-x: hidden;
}
.content {
  margin-left: 300px;
  width: 100%;
  display:flex !important;
  padding: 1px 16px;
  overflow-x: hidden;
}

.mat-header-cell {
  padding: 10px;
}

.mat-column-partnerCode {
  width: 3% !important;
}

.mat-column-partnerTitleSmall {
  width: 25% !important;
}

.childTableProperties.mat-header-row {
  height: 15px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/repository/podrobno/podrobno.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["table {\n  width: 100%;\n  -moz-column-count: 2;\n  -moz-column-gap: 20px;\n  -webkit-column-count: 2;\n  -webkit-column-gap: 20px;\n  column-count: 2;\n  column-gap: 20px;\n}\n\ntr.example-detail-row {\n  height: 0;\n}\n\ntr.example-element-row:not(.example-expanded-row):active {\n  background: #efefef;\n}\n\n.example-element-row td {\n  border-bottom-width: 0;\n}\n\n.example-element-detail {\n  overflow: hidden;\n  display: flex;\n}\n\n.childTable {\n  width: 100%;\n}\n\ntd.mat-cell {\n  width: auto;\n  max-width: 10% !important;\n}\n\nmat-row {\n  width: auto;\n  max-width: 10% !important;\n}\n\ntr.mat-row {\n  height: auto;\n}\n\n.mat-column-uredi {\n  width: 5% !important;\n}\n.mat-column-dataCode {\n  width: 20%;\n}\n.mat-column-dataValue {\n  width: 80%;\n}\n\n.mat-header-cell {\n  background-color: #f89624;\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n}\n\n.parentTableCell {\n  background-color:#ffe8bf !important;\n}\n\n.parentTableCell:nth-child(4n+1) {\n  background-color:#FFF5E3 !important;\n}\n\n/*table coloring*/\n.colorExpandedRow{\n  background-color:#ffe8bf;\n}\n\n/*table coloring*/\n.colorExpandedRow:nth-child(4n+2){\n  background-color:#FFF5E3;\n}\n\n.tableGtSm {\n  height:100%;\n  width:100%;\n}\n\n.sidebarLtMd {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background-color: #f1f1f1;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n  animation: slide-in 0.5s forwards;\n  -webkit-animation: slide-in 0.5s forwards;\n}\n\n.sidebar {\n  margin: 0;\n  padding: 0;\n  width: 300px;\n  display:flex !important;\n  background-color: #f1f1f1;\n  position: fixed;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n}\n.contentLtMd {\n  width: 100%;\n  overflow-x: hidden;\n}\n.content {\n  margin-left: 300px;\n  width: 100%;\n  display:flex !important;\n  padding: 1px 16px;\n  overflow-x: hidden;\n}\n\n.mat-header-cell {\n  padding: 10px;\n}\n\n.mat-column-partnerCode {\n  width: 3% !important;\n}\n\n.mat-column-partnerTitleSmall {\n  width: 25% !important;\n}\n\n.childTableProperties.mat-header-row {\n  height: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
